export default __webpack_public_path__ + "static/media/RETAIL.feaff4fe.png";